import React, {useState, useEffect} from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import {makeStyles} from "@mui/styles";
import styles from "../../assets/jss/material-dashboard-pro-react/cardImagesStyles";
import { DataGrid } from '@mui/x-data-grid';

import Pagination from '@mui/lab/Pagination';
import { TablePagination } from '@mui/material';
import AdvancedSearchContext from "context/AdvancedSearchContext";
import * as locales from '@mui/material/locale';

const useStyles = makeStyles(styles);
const theme = createTheme({
    palette: {
      primary: { main: '#1976d2' },
    },
  }, locales['frFR']);
  const themeFr = createTheme({
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#9798A0',
          // Headers, and top & bottom fixed rows
          containerBackground: '#9798A0',
        },
      },
  }, locales['frFR']);

const useStylesToolbar = makeStyles((theme) => ({
    root: {
        '&.MuiDataGrid-root': {
            color: '#ffffff',
            backgroundColor: '#585667'
        },
        '&.MuiDataGrid-toolbar': {
            color: '#ffffff',
            backgroundColor: '#585667'
        },
    }
}));
const useStylesTable = makeStyles((theme) => ({
    root: {
        height: '90vh',
        '&.MuiDataGrid-root': {
            backgroundColor: '#9798A0',
            border: 'none',
            color: '#ffffff',
            fontSize: '0.875rem',
            height: '90vh',
            backgroundColor: '#605F70;',
            width: '100%',
            fontFamily: '"Source Sans Pro",sans-serif',
            borderRadius: '0px',
        },
        WebkitFontSmoothing: 'auto',
        letterSpacing: 'normal',
        '& .MuiDataGrid-topContainer': {
            backgroundColor: '#9798A0 !important',
        },
        '& .MuiDataGrid-container--top': {
            backgroundColor: '#9798A0 !important',
        },
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: '#9798A0 !important',
        },
        '& .MuiDataGrid-columnHeaders': {
            boder: '#9798A0 !important',
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiTablePagination-input': {
            display: 'none',
        },
        '& .MuiTablePagination-selectLabel': {
            display: 'none',
        },
        '& .MuiDataGrid-withBorderColor': {
            border: 'none !important',
        },
        '& .MuiTablePagination-displayedRows': {
            paddingTop: '8px',
        },
        '& .MuiDataGrid-colCell, .MuiDataGrid-cell': {
            borderRight: `0px`,
        },
        '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
            borderBottom: `0px`,
        },
        '& .MuiDataGrid-cell': {
            color: '#ffffff',
        },
        '& .MuiPaginationItem-root': {
            borderRadius: 1,
        },
        '& .MuiDataGrid-footer , .MuiTablePagination-root': {
            color: '#ffffff'
        },
        '& .MuiDataGrid-menuIcon': {
            color: '#ffffff',
          },
        '& .MuiIconButton-root': {
            color: '#ffffff',
        },
        '& .MuiDataGrid-row': {
            "&:hover": {
                cursor: "pointer"
            },
        },
        '& .MuiDataGrid-columnHeaderRight':{
            padding: 0
        },
        '&.MuiDataGrid-toolbar': {
            color: '#ffffff',
            backgroundColor: '#585667'
        },
        '&.MuiDataGrid-root *': {
            color: '#ffffff',
        },
    },
}));

const lanFr = {
    // Root
    rootGridLabel: 'tableau',
    noRowsLabel: 'Aucune donnée',
    noResultsOverlayLabel: 'Aucun résultat.',
    errorOverlayDefaultLabel: 'Une erreur s\'est produite.',
  
    // Density selector toolbar button text
    toolbarDensity: 'Densité',
    toolbarDensityLabel: 'Densité',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Confortable',
  
    // Columns selector toolbar button text
    toolbarColumns: 'Colonnes',
    toolbarColumnsLabel: 'Choix des colonnes',
  
    // Filters toolbar button text
    toolbarFilters: 'Filtres',
    toolbarFiltersLabel: 'Voir les filtres',
    toolbarFiltersTooltipHide: 'Cacher les filtres',
    toolbarFiltersTooltipShow: 'Voir les filtres',
    toolbarFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtres actifs` : `${count} filtre actif`,
  
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Télécharger en CSV',
  
    // Columns panel text
    columnsPanelTextFieldLabel: 'Touver une colonne',
    columnsPanelTextFieldPlaceholder: 'Nom de la colonne',
    columnsPanelDragIconLabel: 'Réorganiser les colonnes',
    columnsPanelShowAllButton: 'Voir tout',
    columnsPanelHideAllButton: 'Cacher tout',
  
    // Filter panel text
    filterPanelAddFilter: 'Ajouter un filtre',
    filterPanelDeleteIconLabel: 'Supprimer',
    filterPanelOperators: 'Opérateur',
    filterPanelOperatorAnd: 'Et',
    filterPanelOperatorOr: 'Ou',
    filterPanelColumns: 'Colonnes',
    filterPanelInputLabel: 'Valeur',
    filterPanelInputPlaceholder: 'Filtrer la valeur',
  
    // Filter operators text
    filterOperatorContains: 'contient',
    filterOperatorEquals: 'égal',
    filterOperatorStartsWith: 'commence par',
    filterOperatorEndsWith: 'fini par',
    filterOperatorIs: 'est',
    filterOperatorNot: 'n\'est pas',
    filterOperatorAfter: 'est après',
    filterOperatorOnOrAfter: 'est dedans ou après',
    filterOperatorBefore: 'est avant',
    filterOperatorOnOrBefore: 'est dedans ou avant',
  
    // Filter values text
    filterValueAny: 'tout',
    filterValueTrue: 'vrai',
    filterValueFalse: 'faux',
  
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Voir les colonnes',
    columnMenuFilter: 'Filtrer',
    columnMenuHideColumn: 'Cacher',
    columnMenuUnsort: 'Enlever le tri',
    columnMenuSortAsc: 'Tri ascendant',
    columnMenuSortDesc: 'Tri descendant',
  
    // Column header text
    columnHeaderFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtres actifs` : `${count} filtre actif`,
    columnHeaderFiltersLabel: 'Voir les filtres',
    columnHeaderSortIconLabel: 'Trier',
  
    // Rows selected footer text
    footerRowSelected: (count) =>
      count !== 1
        ? `${count.toLocaleString()} lignes selectionnées`
        : `${count.toLocaleString()} ligne selectionnée`,
  
    // Total rows footer text
    footerTotalRows: 'Nombre total de lignes:',
  
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Selection',
  
    // Boolean cell text
    booleanCellTrueLabel: 'vrai',
    booleanCellFalseLabel: 'faux',
  };

   {/*<Pagination
    className={classes.root}
    count={state.pagination.pageCount}
    page={state.pagination.page + 1}
    onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />*/}


 function DataGridHome(props) {
    const classes = useStyles();
    const styledTable = useStylesTable();
     const [ page , setPage] = useState(0);
     const [ pageSize , setPageSize]=useState(10);

    return (
    <ThemeProvider theme={themeFr}>
        <DataGrid
            columns={props.columns} rows={props.rows}
            className={styledTable.root}
            density={"compact"}
            autoHeight={true}
            autoPageSize={false}
            hideFooterSelectedRowCount={true}
            hideFooterRowCount={true}
            headerHeight={80}
            rowHeight={40}
            disableSelectionOnClick={false}
            disableExtendRowFullWidth={false}
            disableColumnMenu={true}
            paginationMode={'client'}
            pagination
            pageSize={pageSize}
            page={page}
            rowsPerPageOptions={[10]}
            scrollbarSize={5}
            showCellRightBorder={false}
            showColumnRightBorder={false}
            sortingMode={'client'}
            columnBuffer={0}
            onRowClick={props.onRowClick}
            localeText={lanFr}
            onPageChange={(params)=>{
                setPage(params.page)
            }}
            onPageSizeChange={(params)=>{
                setPageSize(params.pageSize);
            }}

            />
    </ThemeProvider>
            
    );
}

DataGridHome.propTypes = {
    columns: PropTypes.array,
    rows: PropTypes.array,
    onRowClick: PropTypes.func,
}

export default DataGridHome;